import React from "react";

const PasswordStrengthIndicator = ({
    validity: { minChar, number, specialChar, capsChar }
}) => {
    return (
        <div className="password-meter text-start my-2">
            <span className="small fw-bold text-muted d-block mb-2 text-uppercase" style={{ letterSpacing: '0.04em' }}>
                Password Requirements:
            </span>
            <ul className="d-flex flex-column gap-1 list-unstyled m-0">
                <PasswordStrengthIndicatorItem
                    isValid={minChar}
                    text="At least 8 characters"
                />
                <PasswordStrengthIndicatorItem
                    isValid={number}
                    text="At least 1 numeric digit (0-9)"
                />
                <PasswordStrengthIndicatorItem
                    isValid={specialChar}
                    text="At least 1 special character (!@#$%^&*)"
                />
                <PasswordStrengthIndicatorItem
                    isValid={capsChar}
                    text="At least 1 uppercase letter (A-Z)"
                />
            </ul>
        </div>
    );
};

const PasswordStrengthIndicatorItem = ({ isValid, text }) => {
    const isSuccess = isValid === true;
    const isError = isValid === false;
    
    return (
        <li 
            className={`d-flex align-items-center gap-2 small fw-medium transition-all ${
                isSuccess ? "text-success" : isError ? "text-danger" : "text-muted"
            }`}
            style={{ fontSize: '0.82rem' }}
        >
            <span 
                className="d-inline-flex align-items-center justify-content-center rounded-circle"
                style={{
                    width: '18px',
                    height: '18px',
                    fontSize: '10px',
                    background: isSuccess ? '#dcfce7' : isError ? '#fee2e2' : '#f1f5f9',
                    color: isSuccess ? '#16a34a' : isError ? '#dc2626' : '#94a3b8'
                }}
            >
                <i className={`fa ${isSuccess ? "fa-check" : isError ? "fa-times" : "fa-circle-o"}`}></i>
            </span>
            <span>{text}</span>
        </li>
    );
};

export default PasswordStrengthIndicator;